module.exports = __webpack_public_path__ + "static/media/Team.bf8fa717.svg";